import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaginationService } from 'ngx-pagination';
import { ListBaseComponent } from '../../../shared/components/base/list-base/list-base.component';
import { DocumentIntelligenceRequestFilter } from '../../../shared/filters/document-intelligence-request.filter';
import { Permissions } from '../../../shared/constants/permissions';
import { SectionService } from '../../../shared/services/section.service';
import { DocumentIntelligenceService } from '../../../shared/services/document-intelligence.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Sections } from '../../../shared/constants/sections';
import { Modals } from '../../../shared/constants/modals';
import { Constants } from '../../../shared/constants/constants';
import { CompanyBase } from '../../../shared/models/company-base.model';
import { DocumentIntelligenceRequest } from '../../../shared/models/document-intelligence-request.model';

@Component({
  selector: 'app-requests-list',
  templateUrl: './requests-list.component.html',
  styleUrls: ['./requests-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class RequestsListComponent extends ListBaseComponent implements OnInit {
    fieldCollection = [
      { name: 'CompanyName', displayName: 'documentIntelligenceRequests.companyNameFieldTitle', canSort: true, displayClass: '' },
      { name: 'FileName', displayName: 'documentIntelligenceRequests.fileNameFieldTitle', canSort: false, displayClass: ''},
      { name: 'Status', displayName: 'documentIntelligenceRequests.statusFieldTitle', canSort: true, displayClass: ''},
      { name: 'ModelId', displayName: 'documentIntelligenceRequests.modelIdFieldTitle', canSort: true, displayClass: ''},
      { name: 'Provider', displayName: 'documentIntelligenceRequests.providerFieldTitle', canSort: true, displayClass: '' },
      { name: 'Format', displayName: 'documentIntelligenceRequests.formatFieldTitle', canSort: true, displayClass: ''},
    ];

    documentIntelligenceFilter: DocumentIntelligenceRequestFilter;
    statusesUpdatedSuccessfullyMessage: string;

    get companySelectionListClass(): string {
      if (this.hasSelectCompanyPermission) {
        return 'd-none d-xl-block selection-list'
      }

      return '';
    }

    get hasSelectCompanyPermission(): boolean {
      return this.hasPermission(Permissions.DocumentIntelligence_SelectCompany);
    }

    get hasViewModelPermission(): boolean {
      return this.hasPermission(Permissions.DocumentIntelligence_Request_View);
    }

    constructor(
      protected sectionService: SectionService,
      protected documentIntelligenceService: DocumentIntelligenceService,
      protected translateService: TranslateService,
      protected toastrService: ToastrService) {
        super(sectionService, Sections.DocumentIntelligence);
    }

    ngOnInit(): void {
      this.documentIntelligenceFilter = new DocumentIntelligenceRequestFilter();
      super.initializeView(Constants.DocumentIntelligence_Requests_DefaultSortField, Constants.DocumentIntelligence_Requests_DefaultSortDirectionAscending);
      this.translateService.get(['documentIntelligenceRequests.statusesUpdatedSuccessfullyMessage'])
        .subscribe(translations => {
          this.statusesUpdatedSuccessfullyMessage = translations['documentIntelligenceRequests.statusesUpdatedSuccessfullyMessage']
        })
    }

    getCollection(pageNumber: number = 1) {
      if (pageNumber) {
        this.pageConfiguration.PageNumber = pageNumber
      }
      this.documentIntelligenceService.getCollectionPaginated<DocumentIntelligenceRequest>(
        `/document-intelligence/requests`,
        this.pageConfiguration,
        this.documentIntelligenceFilter,
        (collection: DocumentIntelligenceRequest[]) => { this.collection = collection; }
      )
    }

    handleCompanyChanged(company: CompanyBase): void {
      if (company) {
        this.documentIntelligenceFilter.CompanyId = company.CompanyId;
      }
      else {
        this.documentIntelligenceFilter.CompanyId = undefined;
      }
  
      this.getCollection(Constants.DefaultPageNumber);
    }
  
    handleBooleanToggleFilterChanged(): void {
      this.getCollection();
    }

    getStatusIcon(status: string): string {
      switch (status) {
        case 'Pending':
          return 'icon-clock';
        case 'Finished':
          return 'icon-check';
        case 'Error':
          return 'icon-close';
        default:
          return 'icon-question';
      }
    }
}
